import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormControl,
} from '@angular/forms';
import { ApiService } from '../../utils/services/api.service';
import { ToastrService } from 'ngx-toastr';
//import { Router } from '@angular/router';
import { ActivatedRoute, Router } from '@angular/router';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-adventure-type',
  templateUrl: './adventure-type.component.html',
  styleUrls: ['./adventure-type.component.scss']
})
export class AdventureTypeComponent implements OnInit {
   addAdventureForm: FormGroup;
  public cancelCatRoute: string;
  private advanid: any;
  getData: any;
  public isAuthLoading = false;
  public isAuthDisabled = false;
  private _userId: string = localStorage.getItem('id');

  constructor(
    private formBuilder: FormBuilder,
    //private router: Router,
    private apiService: ApiService,
    //private toastr: ToastrService,
    private router: Router,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.addAdventureForm = new FormGroup({
      adventure_type: new FormControl(),
      status: new FormControl(),
      slug_url: new FormControl(),
      // user_id: new FormControl(),
      //display_sequence: new FormControl()
    });
     this.advanid = this.route.snapshot.paramMap.get('adventure_id');
    // console.log(this.news_id, this.news_type);
    if (
      this.advanid != undefined &&
      this.advanid != null &&
      this.advanid != ''
    ) {
      this.editpack(this.advanid);
    } else {
      this.addAdventureForm.get('status').setValue('active');
    }
  }

  editpack(id) {
    let dataForForm = {
      id: id,
    };
    this.apiService.getAdvenId(dataForForm).subscribe((result: any) => {
      console.log(result.getData);
      if (result.success) {
        this.addAdventureForm.patchValue({
          adventure_type: result.getData.adventure_type,
          slug_url: result.getData.adventure_type,
        });
        if (result.getData.status == 'active') {
          this.addAdventureForm.get('status').setValue('active');
        }
        //  if(blogData.status == "active") {
        //   this.addBlogForm.get('status').setValue('active');
        // }
      }
    });
  }

  addAdventure() {
    if (
      this.addAdventureForm.value.adventure_type== undefined ||
      this.addAdventureForm.value.adventure_type.trim() == ''
    ) {
      Swal.fire({
        text: 'Please enter adventure type',
        icon: 'warning',
      });
      return false;
      // this.toastr.error("Please Enter the Language");
      // return false;
    }

    if (!this.addAdventureForm.value.slug_url) {
      this.addAdventureForm.get('slug_url').setValue(this.addAdventureForm.value.adventure_type);
    }
    // if (
    //   this.addAdventureForm.value.this._userId == undefined ||
    //   this.addAdventureForm.value.boarding.trim() == ''
    // )
    if (this.addAdventureForm.status == 'active') {
      this.addAdventureForm.get('status').setValue('active');
    }
    if (this.advanid != undefined && this.advanid != null && this.advanid != '') {
      this.updateAdventure(this.advanid);
    } else {
      this.addAdventureForm.value.user_id = this._userId;
      this.isAuthLoading = true;
      this.isAuthDisabled = true;
      this.apiService
        .addAdven(this.addAdventureForm.value)
        .subscribe((res: any) => {
          console.log(res);
          if (res.success) {
            this.isAuthLoading = false;
            this.isAuthDisabled = false;
            //this.toastr.success(res.message);
            Swal.fire({
              text: res.message,
              icon: 'success',
            });
            this.router.navigateByUrl('/adventure-type-list');
          } else {
            this.isAuthLoading = false;
            this.isAuthDisabled = false;
            //this.toastr.error(res.message);
            Swal.fire({
              text: res.message,
              icon: 'error',
            });
          }
        });
    }
  }
    updateAdventure(id) {
    this.isAuthLoading = true;
    this.isAuthDisabled = true;
    this.apiService
      .updateAdven(this.addAdventureForm.value, id)
      .subscribe((res: any) => {
        if (res.success) {
          this.isAuthLoading = false;
          this.isAuthDisabled = false;
          //this.toastr.success(res.message);
          Swal.fire({
            text: res.message,
            icon: 'success',
          });
          this.router.navigateByUrl('/adventure-type-list');
        } else {
          this.isAuthLoading = false;
          this.isAuthDisabled = false;
          Swal.fire({
            text: res.message,
            icon: 'error',
          });
          //this.toastr.error(res.message);
        }
      });
  }

}
